'use strict';

import $ from 'jquery';
window.$ = window.jQuery = $;
import '@fancyapps/fancybox';
import lozad from 'lozad';

const observer = lozad('.lozad');

$('.lazy-load-list').on('click', function() {
    $('#' + $(this).data('result')).html('<i class="fa-spinner fa-pulse"><svg aria-hidden="true" focusable="false" data-prefix="fas" data-icon="spinner" class="svg-inline--fa fa-spinner fa-w-16" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512"><path fill="currentColor" d="M304 48c0 26.51-21.49 48-48 48s-48-21.49-48-48 21.49-48 48-48 48 21.49 48 48zm-48 368c-26.51 0-48 21.49-48 48s21.49 48 48 48 48-21.49 48-48-21.49-48-48-48zm208-208c-26.51 0-48 21.49-48 48s21.49 48 48 48 48-21.49 48-48-21.49-48-48-48zM96 256c0-26.51-21.49-48-48-48S0 229.49 0 256s21.49 48 48 48 48-21.49 48-48zm12.922 99.078c-26.51 0-48 21.49-48 48s21.49 48 48 48 48-21.49 48-48c0-26.509-21.491-48-48-48zm294.156 0c-26.51 0-48 21.49-48 48s21.49 48 48 48 48-21.49 48-48c0-26.509-21.49-48-48-48zM108.922 60.922c-26.51 0-48 21.49-48 48s21.49 48 48 48 48-21.49 48-48-21.491-48-48-48z"></path></svg></i>');

    $.ajax({
        url: $(this).data('post') + '/index.json',
        dataType: 'json'
    }).done((data) => {
        console.log(data.data)
        console.log($(this).data('result'));
        $('#' + $(this).data('result')).html(data.data);
        $(this).removeClass('lazy-load-list');
        $(this).removeClass('sm:col-span-1');
        $(this).off('click');
        loadImages();
    });
});

$(document).ready(function () {

    $.fancybox.defaults.hideScrollbar = false;

    // show passed appointments
    $('.timeline-badge').on('click', function() {
        let next = $(this).data('time');
        let li = $(this).parent('li');
        let panel = li.find('.timeline-panel');
        if (li.hasClass('shown')) {
            $(li).removeClass('shown');
            panel.html('<span class="big">' + next + '</span>');
        } else {
            panel.load('/wirkungsorte/' + next, () => {
                $(li).addClass('shown');
                loadImages();
            });
        }
    });
    $('.timeline-panel').on('click', function() {
        let li = $(this).parent('li');
        let next = $(this).data('time');
        if (li.hasClass('shown')) {
            // TODO: something here
        } else {
            $(this).load('/wirkungsorte/' + next, () => {
                $(li).addClass('shown');
                loadImages();
            });
        }
    });

    loadImages();

    // $('[data-fancybox]').fancybox({
    //     lang : 'de'
    // });

    $('.spam').on('click', function() {
        location.href=fuckup($(this).data('spam'));
    });
    function fuckup(p) {
        let b = parseInt(p.substring([+[]]+[], 2));
        p = p.substring(2);
        let c = '';
        for (let i = [+[]]+[]; i < p.length / 3; i -= -1) {
            let n = p.substring(i * 3, i * 3 + 3);
            let a = i % 2 ? parseInt(n) - b : parseInt(n) + b;
            a = parseInt(n) > 300 ? a - 500 : a;
            c += String.fromCharCode(a);
        }
        return c;
    }
});

async function loadImages() {
    observer.observe();
}